import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../data/content";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const Faq = () => (
    <section data-testid="faq-section" className="bg-mist py-24 lg:py-32">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-10">
            <SectionHeading
                number="10"
                eyebrow="FAQ"
                title="Questions,"
                accent="Answered"
                sub="Everything you need to know before your visit."
            />
            <Reveal delay={0.15}>
                <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="rounded-2xl border border-ink/10 bg-white px-6 transition-[border-color,box-shadow] duration-300 data-[state=open]:border-teal-600/40 data-[state=open]:shadow-[0_16px_40px_-20px_rgba(13,148,136,0.4)]"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i}`}
                                className="py-5 text-left font-display text-lg text-ink hover:no-underline [&[data-state=open]]:text-teal-700"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent
                                data-testid={`faq-content-${i}`}
                                className="pb-5 text-sm leading-relaxed text-slate-600"
                            >
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
